<template>
    <div class="tabcontent tabcontent-border-style">
        <div class="table-container" v-if="users.length > 0">
            <TableComponent model="users" name="user" :keys="keys" :thead="thead" :tbody="users"
                            updateUrl="/settings/user/edit"
                            @sort="sortUsers"
                            @update="updateHandler($event)"/>

            <div class="paginationLink">
                <pagination :data="laravelData" @pagination-change-page="handlePagination($event)" :limit="3">
                    <template #prev-nav><span>Previous</span></template>
                    <template #next-nav><span>Next</span></template>
                </pagination>
            </div>
        </div>
        <div v-else class="d-flex flex-column justify-content-center align-items-center gap-2 h-75 m-auto">
            <div class="h3Organization">
                <h3 v-if="!isSearchActive">You Don't Have Any Users Yet</h3>
                <h3 v-else>No Data</h3>
            </div>
            <router-link class="text-decoration-none btn-container btn-container-no-data"
                         v-if="permissions.includes('create user') && users.length === 0 && !isSearchActive"
                         to="/settings/user/create">
                <span>Create User</span>
            </router-link>
        </div>
    </div>
</template>

<script>
    import {useStore} from "vuex";
    import {ref, onMounted, computed, watch} from "vue"; // Added watch/computed
    import TableComponent from "../../components/TableComponent";
    import repository from "../../../api-services/repository";
    import LaravelVuePagination from 'laravel-vue-pagination';

    export default {
        name: 'setting-user-page',
        components: {TableComponent, 'Pagination': LaravelVuePagination},
        // 1. Define Props
        props: ['globalSearch', 'globalSort'],
        setup(props, context) {
            const store = useStore();
            let users = ref([]);
            let state = ref(false);
            let originalUsers = ref([]);
            const thead = ref(['Users', 'User Email']);
            const permissions = ref([]);
            const keys = ref(['name', 'email']);
            const laravelData = ref({});

            // Computed property for search state
            const isSearchActive = computed(() => props.globalSearch !== '');

            // 2. Watch props
            watch(() => props.globalSearch, (newVal) => {
                getUsers(1);
            });
            watch(() => props.globalSort, (newVal) => {
                getUsers(1);
            });

            onMounted(async () => {
                await store.dispatch('activeTap', 'settings');
                permissions.value = await store.state.auth.permissions;
                await getUsers(1);
            });

            const handlePagination = async (pageNumber) => {
                await getUsers(pageNumber);
            };

            const getUsers = async (page = 1) => {
                try {
                    // 3. Use props
                    const sortVal = props.globalSort !== '' ? props.globalSort : 'desc';
                    // Note: 'repository.index' arguments order seems to be (model, search, sort, ..., page)
                    let usersData = await repository.index('users', props.globalSearch, sortVal, true, page);
                    
                    laravelData.value = usersData.data.data;

                    usersData.data.data.data.forEach((user) => {
                        user['delateFlag'] = user.entities_count === 0
                    });
                    users.value = usersData.data.data.data
                    originalUsers.value = usersData.data.data.data;

                    if(users.value.length > 0){
                        await context.emit('data-event', {'user': {action:true, search: isSearchActive.value}});
                    }else{
                        await context.emit('data-event', {'user': {action:false, search: isSearchActive.value}});
                    }
                } catch (e) {
                    if (process.env.VUE_ENV === 'development')
                        console.log({e})
                }
            };

            const sortUsers = (e) => {
                let status = !state.value;
                users.value.sort(function (a, b) {
                    return status ? -(a.id - b.id || a.name.localeCompare(b.name)) : -(b.id - a.id || b.name.localeCompare(a.name));
                });
                state.value = status;
            };

            const updateHandler = async (event) => {
                users.value = users.value.filter((user) => {
                    return user.id !== event
                })
                originalUsers.value = [...users.value];
                await getUsers();
            };

            return {
                thead, keys, users, laravelData, state, permissions,
                getUsers, sortUsers, updateHandler, handlePagination,
                isSearchActive
            }
        }
    }
</script>
<style scoped>
    .table-container :deep(thead :first-child){
        width:30% !important;
    }
    .table-container :deep(thead :nth-child(2)){
        width:50% !important;
    }
</style>